import { IBrandingState } from '@wonderschool/common-base-sso/urls/authUrls'
import { IWhitelabelContext, Networks } from 'main/framework'
import { SchoolListingType as ListingType } from 'main/gql/globalTypes'
import { palette, WONDERSCHOOL_LOGO, WONDERSCHOOL_LOGO_SMALL } from 'main/ui'
import {
  attributes as faviconAttributes,
  IAttributes as IFaviconAttributes,
  Size as FaviconSize,
} from 'main/util/favicon'

interface IAsset {
  name: AssetName
  value: string
}

type Marker = {
  [key in ListingType]?: string
}

interface IMarkers {
  [AssetName.MARKER]: Marker
  [AssetName.MARKER_SELECTED]: Marker
}

export enum AssetName {
  ACCEPTS_SUBSIDY = 'ACCEPTS_SUBSIDY',
  AGE_RANGE_START_AT_SIX_WEEKS = 'AGE_RANGE_START_AT_SIX_WEEKS',
  COVID_FILTERS = 'COVID_FILTERS',
  DEFAULT_HEADER__OFF_PLATFORM = 'DEFAULT_HEADER__OFF_PLATFORM',
  FAVICON = 'FAVICON',
  FOOTER = 'FOOTER',
  I18N_SUFFIX = 'I18N_SUFFIX',
  LICENSE_NUMBER_PROOF_LINK = 'LICENSE_NUMBER_PROOF_LINK',
  LOGO = 'LOGO',
  LOGO_LINK_URL = 'LOGO_LINK_URL',
  LOGO_SMALL = 'LOGO_SMALL',
  MARKER = 'MARKER',
  MARKER_SELECTED = 'MARKER_SELECTED',
  MARKER_SELECTED__OFF_PLATFORM = 'MARKER_SELECTED__OFF_PLATFORM',
  MARKER__OFF_PLATFORM = 'MARKER__OFF_PLATFORM',
  NETWORK_ABBR = 'NETWORK_ABBR',
  NETWORK_RATING_COLOR = 'NETWORK_RATING_COLOR',
  NETWORK_RATING_DISPLAY__DETAIL__BASICS = 'NETWORK_RATING_DISPLAY__DETAIL__BASICS',
  NETWORK_RATING_DISPLAY__SEARCH__CALLOUT = 'NETWORK_RATING_DISPLAY__SEARCH__CALLOUT',
  NETWORK_RATING_FILTERS = 'NETWORK_RATING_FILTERS',
  NETWORK_RATING_FILTERS_V2 = 'NETWORK_RATING_FILTERS_V2',
  NETWORK_RATING_LEARN_MORE = 'NETWORK_RATING_LEARN_MORE',
  NETWORK_RATING_SYMBOL = 'NETWORK_RATING_SYMBOL',
  NETWORK_RATING_SYSTEM_TITLE = 'NETWORK_RATING_SYSTEM_TITLE',
  NETWORK_RATING_SYSTEM_SUBTITLE = 'NETWORK_RATING_SYSTEM_SUBTITLE',
  NETWORK_CONTACT_DETAILS__SCHOOL_PAGE__TITLE = 'NETWORK_CONTACT_DETAILS__SCHOOL_PAGE__TITLE',
  NETWORK_CONTACT_DETAILS__SEARCH_PAGE__TITLE = 'NETWORK_CONTACT_DETAILS__SEARCH_PAGE__TITLE',
  NETWORK_CONTACT_DETAILS__BODY = 'NETWORK_CONTACT_DETAILS__BODY',
  NETWORK_CONTACT_DETAILS__PHONE = 'NETWORK_CONTACT_DETAILS__PHONE',
  NOT_LICENSED_LINK = 'NOT_LICENSED_LINK',
  NOT_LICENSED_LINK__ONBOARDING = 'NOT_LICENSED_LINK__ONBOARDING',
  PRIMARY_ACCENT_COLOR = 'PRIMARY_ACCENT_COLOR',
  PRIMARY_COLOR = 'PRIMARY_COLOR',
  PROGRAM_OFFERINGS = 'PROGRAM_OFFERINGS',
  PROGRAM_OFFERINGS_BASICS_FORM_TITLE = 'PROGRAM_OFFERINGS_BASICS_FORM_TITLE',
  PROGRAM_OFFERINGS_BASICS_FORM_SUBTITLE = 'PROGRAM_OFFERINGS_BASICS_FORM_SUBTITLE',
  REFER_A_FRIEND = 'REFER_A_FRIEND',
  SAVE_SEARCH_BUTTON = 'SAVE_SEARCH_BUTTON',
  SAVE_SEARCH_FORM = 'SAVE_SEARCH_FORM',
  SECONDARY_ACCENT_COLOR = 'SECONDARY_ACCENT_COLOR',
  SECONDARY_COLOR = 'SECONDARY_COLOR',
  SIGN_UP__HEADER = 'SIGN_UP__HEADER',
  SIGN_UP__SSOLOGIN = 'SIGN_UP__SSOLOGIN',
  SPECIAL_NEEDS_FIELDS = 'SPECIAL_NEEDS_FIELDS',
  START_A_WONDERSCHOOL = 'START_A_WONDERSCHOOL',
  SUBSIDY_ELIGIBILITY_FORM = 'SUBSIDY_ELIGIBILITY_FORM',
  SUBSIDY_ELIGIBILITY_COPY_1 = 'SUBSIDY_ELIGIBILITY_COPY_1',
  SUBSIDY_ELIGIBILITY_COPY_2 = 'SUBSIDY_ELIGIBILITY_COPY_2',
  SUBSIDY_ELIGIBILITY_COPY_3 = 'SUBSIDY_ELIGIBILITY_COPY_3',
  SUBSIDY_ELIGIBILITY_COPY_4 = 'SUBSIDY_ELIGIBILITY_COPY_4',
  SUBSIDY_ELIGIBILITY_COPY_5 = 'SUBSIDY_ELIGIBILITY_COPY_5',
  SUBSIDY_ELIGIBILITY_LINK_5 = 'SUBSIDY_ELIGIBILITY_LINK_5',
  SUBSIDY_ELIGIBILITY_LINK_5_TEXT = 'SUBSIDY_ELIGIBILITY_LINK_5_TEXT',
  SUBSIDY_ELIGIBILITY_LINK_1_TEXT = 'SUBSIDY_ELIGIBILITY_LINK_1_TEXT',
  SUBSIDY_ELIGIBILITY_LINK_1 = 'SUBSIDY_ELIGIBILITY_LINK_1',
  SUBSIDY_ELIGIBILITY_LINK_2_TEXT = 'SUBSIDY_ELIGIBILITY_LINK_2_TEXT',
  SUBSIDY_ELIGIBILITY_LINK_2 = 'SUBSIDY_ELIGIBILITY_LINK_2',
  SUBSIDY_ELIGIBILITY_LINK_3_TEXT = 'SUBSIDY_ELIGIBILITY_LINK_3_TEXT',
  SUBSIDY_ELIGIBILITY_LINK_3 = 'SUBSIDY_ELIGIBILITY_LINK_3',
  SUBSIDY_ELIGIBILITY_TITLE = 'SUBSIDY_ELIGIBILITY_TITLE',
  TERTIARY_ACCENT_COLOR = 'TERTIARY_ACCENT_COLOR',
  TERTIARY_COLOR = 'TERTIARY_COLOR',
  WONDERSCHOOL_RATING_DISPLAY__LISTING__DIRECTOR_PROFILE = 'WONDERSCHOOL_RATING_DISPLAY__LISTING__DIRECTOR_PROFILE',
  WONDERSCHOOL_RATING_DISPLAY__SEARCH__CALLOUT = 'WONDERSCHOOL_RATING_DISPLAY__SEARCH__CALLOUT',
  LOGO_AND_SEARCH_BACKGROUND_COLOR = 'LOGO_AND_SEARCH_BACKGROUND_COLOR',
  SUBSIDY_ALT_TEXT_DASHBOARD_MYWEBSITE_BASICS_SUBSIDIZED_TITLE = 'SUBSIDY_ALT_TEXT_DASHBOARD_MYWEBSITE_BASICS_SUBSIDIZED_TITLE',
  SUBSIDY_ALT_TEXT_DASHBOARD_MYWEBSITE_BASICS_SUBSIDIZED_QUESTION = 'SUBSIDY_ALT_TEXT_DASHBOARD_MYWEBSITE_BASICS_SUBSIDIZED_QUESTION',
  SUBSIDY_ALT_TEXT_INTERNALSCHOOL_BASICS_SUBSIDIZED_TITLE = 'SUBSIDY_ALT_TEXT_INTERNALSCHOOL_BASICS_SUBSIDIZED_TITLE',
  EXTERNAL_LICENSE_URL = 'EXTERNAL_LICENSE_URL',
  SUBSIDY_BUDGET_FILTER = 'SUBSIDY_BUDGET_FILTER',
}

export type NetworkMarkers = IMarkers

export type Asset = IAsset

export function retrieveMarkers(whitelabel: IWhitelabelContext): NetworkMarkers | undefined {
  if (!whitelabel.isWhitelabeled) return

  const marker: Marker = {}
  const markerSelected: Marker = {}

  marker[ListingType.INTERNAL] = whitelabel.getAsset(AssetName.MARKER)
  marker[ListingType.EXTERNAL] = whitelabel.getAsset(AssetName.MARKER__OFF_PLATFORM)

  markerSelected[ListingType.INTERNAL] = whitelabel.getAsset(AssetName.MARKER_SELECTED)
  markerSelected[ListingType.EXTERNAL] = whitelabel.getAsset(
    AssetName.MARKER_SELECTED__OFF_PLATFORM,
  )

  return {
    [AssetName.MARKER]: marker,
    [AssetName.MARKER_SELECTED]: markerSelected,
  }
}

export interface IFiltersPalette {
  bar: { [key in FilterBar]: string }
  control: {
    [key in FilterControl]: {
      [state in FilterState]: string
    }
  }
}

export enum FilterBar {
  BACKGROUND,
}

export enum FilterControl {
  BUTTON,
  TEXT,
}

export enum FilterState {
  ACTIVE,
  INACTIVE,
}

export enum View {
  WEB,
  MOBILE,
}

export interface IFiltersPalette {
  bar: {
    [key in FilterBar]: string
  }
  control: {
    [key in FilterControl]: {
      [state in FilterState]: string
    }
  }
}

export function filtersPalette(whitelabel: IWhitelabelContext): IFiltersPalette {
  return { bar: bar(whitelabel), control: control(whitelabel) }
}

function bar(whitelabel: IWhitelabelContext) {
  const primaryColor = whitelabel.getAsset(AssetName.PRIMARY_COLOR)

  return {
    [FilterBar.BACKGROUND]: primaryColor || palette.white,
  }
}

function control(whitelabel: IWhitelabelContext) {
  const primaryColor = whitelabel.getAsset(AssetName.PRIMARY_COLOR)
  const secondaryColor = whitelabel.getAsset(AssetName.SECONDARY_COLOR)

  const activeButton = primaryColor || palette.skyBlue2
  const inactiveButton = primaryColor || palette.lightGray

  const activeText = secondaryColor || palette.white
  const inactiveText = secondaryColor ? palette.white : palette.slate

  return {
    [FilterControl.BUTTON]: {
      [FilterState.ACTIVE]: activeButton,
      [FilterState.INACTIVE]: inactiveButton,
    },
    [FilterControl.TEXT]: {
      [FilterState.ACTIVE]: activeText,
      [FilterState.INACTIVE]: inactiveText,
    },
  }
}

export function buildAuthBranding(whitelabel: IWhitelabelContext): IBrandingState {
  return {
    disclaimer: {
      key: `AUTH-TOS-PRIVACY-DISCLAIMER${whitelabel.i18nSuffix}`,
      params: disclaimerParams(whitelabel),
    },
    ...favicons(whitelabel),
    ...logos(whitelabel),
    ...network(whitelabel),
  }
}

function disclaimerLookup(abbr: string | undefined) {
  switch (abbr) {
    case Networks.ELI:
      return {
        ws_eli_tos: 'https://wonderschool.com/corp/terms',
        ws_eli_privacy: 'https://wonderschool.com/corp/privacy',
        eli_tos: 'https://theearlylearningmarketplace.org/terms/',
        eli_privacy: 'https://theearlylearningmarketplace.org/privacy/',
      }
    case Networks.NM:
      return {
        nm_tos: 'https://www.nmececd.org/child-care-finder-terms-conditions-and-privacy-policy/',
        ws_tos: 'https://wonderschool.com/corp/terms',
        ws_privacy: 'https://wonderschool.com/corp/privacy',
      }
    case Networks.FLDOE:
      return {
        fldoe_tos: 'https://www.nmececd.org/child-care-finder-terms-conditions-and-privacy-policy/',
        ws_tos: 'https://wonderschool.com/corp/terms',
        ws_privacy: 'https://www.wonderschool.com/corp/florida-privacy-policy',
      }
    default:
      return { tos: '/terms-of-use', privacy: '/privacy-policy' }
  }
}

function disclaimerParams(whitelabel: IWhitelabelContext) {
  return disclaimerLookup(whitelabel.networkAbbr)
}

function favicons(whitelabel: IWhitelabelContext): {
  favicon: IFaviconAttributes
  faviconSmall: IFaviconAttributes
} {
  const favicon = whitelabel.getAsset(AssetName.FAVICON)

  return {
    favicon: faviconAttributes(FaviconSize.LARGE, favicon),
    faviconSmall: faviconAttributes(FaviconSize.SMALL, favicon),
  }
}

function logos(whitelabel: IWhitelabelContext): { logo: string; logoSmall: string } {
  let logo = whitelabel.getAsset(AssetName.LOGO)
  logo = logo ? `${logo}-/resize/200x/-/quality/smart/` : WONDERSCHOOL_LOGO

  let logoSmall = whitelabel.getAsset(AssetName.LOGO_SMALL)
  logoSmall = logoSmall ? `${logoSmall}-/resize/40x/-/quality/smart/` : WONDERSCHOOL_LOGO_SMALL

  return { logo, logoSmall }
}

function network(whitelabel: IWhitelabelContext): {
  networkAbbr: string | undefined
  networkId: string | undefined
  networkName: string | undefined
  networkAutoMigrateCcms: boolean | null | undefined
} {
  return {
    networkAbbr: whitelabel.networkAbbr,
    networkId: whitelabel.networkId,
    networkName: whitelabel.networkName,
    networkAutoMigrateCcms: whitelabel.networkAutoMigrateCcms,
  }
}
